import theme from './theme.json'
import themeLatest from './theme-latest.json'
import sizeConfig from './size-config.json'
import { SIZE_CATEGORY } from '@/__v1.5__/constants/ui.constants'

export const setupTheme = (themeId = 'light', widgetRef = null, providedThemeConfig = null, version = 'current') => {
  let chosenTheme = theme

  if (version === 'latest') {
    chosenTheme = themeLatest
  }

  const themeConfig = providedThemeConfig || chosenTheme[themeId]

  const root = widgetRef?.value || document.documentElement

  Object.keys(themeConfig).forEach(key => {
    root.style.setProperty(key, themeConfig[key])
  })
}

/**
 * @param { Ref<HTMLDivElement> } widgetRef
 * @param { 'medium-to-large' | 'small-to-medium' } sizeCategory
 * @returns { Promise<void> }
 **/
export const setupThemeSize = (widgetRef, sizeCategory) => {
  const categorySizeConfig = sizeConfig[sizeCategory]

  const root = widgetRef?.value || document.documentElement

  Object.keys(categorySizeConfig).forEach(key => {
    root.style.setProperty(`--szw-${key}`, categorySizeConfig[key])
  })
}

export const getSizeCategory = width => (width < 480 ? SIZE_CATEGORY.SM_TO_MD : SIZE_CATEGORY.MD_TO_LG)
